import React, { useState } from 'react';
import { postAnexoEva } from '../services/api';
import '../styles/modal.css';

const AnexoModal = ({ isOpen, onClose, idEva, pacienteNombre, onSuccess }) => {
  const [archivo, setArchivo] = useState(null);
  const [observaciones, setObservaciones] = useState('');
  const [cargando, setCargando] = useState(false);
  const [error, setError] = useState(null);

  if (!isOpen) return null;

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setArchivo(e.target.files[0]);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!archivo) {
      setError('Debes seleccionar un archivo.');
      return;
    }

    try {
      setCargando(true);
      setError(null);

      const formData = new FormData();
      formData.append('file', archivo);
      formData.append('observaciones', observaciones);

      await postAnexoEva(idEva, formData);
      setArchivo(null);
      setObservaciones('');
      onSuccess();
      onClose();
    } catch (err) {
      console.error('Error al subir anexo:', err);
      setError(err.response?.data?.message || 'Error al subir el archivo anexo.');
    } finally {
      setCargando(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-container" onClick={(e) => e.stopPropagation()}>

        <div className="modal-header">
          <h3>Subir Anexo {pacienteNombre ? `- ${pacienteNombre}` : ''}</h3>
          <button type="button" className="btn-close" onClick={onClose}>
            &times;
          </button>
        </div>
        <form onSubmit={handleSubmit} className="modal-body">
          {error && <div className="alert-error">{error}</div>}

          <div className="form-group">
            <label htmlFor="file-input">Seleccionar Archivo (PDF, Imagen, Doc):</label>
            <input
              id="file-input"
              type="file"
              onChange={handleFileChange}
              disabled={cargando}
            />
            {archivo && (
              <p className="file-name-selected">
                <i className="fas fa-file"></i> {archivo.name}
              </p>
            )}
          </div>

          <div className="form-group">
            <label htmlFor="obs-input">Comentarios / Observaciones:</label>
            <textarea
              id="obs-input"
              rows="3"
              placeholder="Ej: Certificado de especialidad médica..."
              value={observaciones}
              onChange={(e) => setObservaciones(e.target.value)}
              disabled={cargando}
            />
          </div>

          <div className="modal-footer">
            <button
              type="button"
              className="btn-secondary"
              onClick={onClose}
              disabled={cargando}
            >
              Cancelar
            </button>
            <button
              type="submit"
              className="btn-primary"
              disabled={cargando || !archivo}
            >
              {cargando ? 'Subiendo...' : 'Subir Anexo'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AnexoModal;